<script>
import { authComputed, authMethods } from '@state/helpers'

import MetisMenu from 'metismenujs/dist/metismenujs'

export default {
  components: {},
  data(){
    return {
      menu: []
    }
  },
  computed: {
    ...authComputed,
    getMenu: function () {
      return this.$store.state.auth.currentSession ? this.$store.state.auth.currentSession.user.app_sections_tree : []
    }
  },
  mounted: function() {
    // eslint-disable-next-line no-unused-vars
    var menuRef = new MetisMenu('#side-menu',{
      activeClass: 'mm-active',
      toggle: false
    })
    menuRef.update()
  },
  created: function() {
    if (this.loggedIn){
      this.setUserActiveSection(this.$route.path)
    }
  },
  methods: {
    ...authMethods
  },
}
</script>

<template>
  <!--- Sidemenu -->
  <div id="sidebar-menu">
    <ul id="side-menu"  class="metismenu">
      <!-- <li class="menu-title">Navigation</li> -->
      <li v-for="(entry, index) in getMenu" :id="`first-lv-${index}-${entry.id}`" :key="index"  :class="{ active: entry.active }">
        <router-link v-if="'path' in entry && entry.path"  tag="a" :to=" { path: entry.path }" :class="{ active: entry.active }" :aria-expanded="true">
          <FontAwesomeIcon fixed-width :icon="entry.icon_name || 'fe-arrow-right'" />
          <span> {{ entry.name }} </span>
          <span v-if="entry.children" class="menu-arrow"></span>
        </router-link>
        <a v-else  href="javascript: void(0);" class="waves-effect" :aria-expanded="true">
          <FontAwesomeIcon fixed-width :icon="entry.icon_name || 'fe-arrow-right'" />
          <span> {{ entry.name }}</span>
          <span v-if="entry.children" class="menu-arrow"></span>
        </a>
        <!-- <b-tooltip v-if="'hover_text' in entry && entry.hover_text" :target="`first-lv-${index}-${entry.id}`" placement="right" variant="info">
          {{ entry.hover_text }}
        </b-tooltip> -->
        <!-- if menu entry has children -->
        <ul v-if="entry.children" class="nav-second-level nav">
          <li v-for="(childsecondlv, chsecondlvidx) in entry.children" :id="`second-lv-${chsecondlvidx}-${entry.id}-${childsecondlv.id}`" :key="chsecondlvidx" :class="{ active: childsecondlv.active }">
            <router-link v-if="'path' in childsecondlv && childsecondlv.path" tag="a" :to="{ path: childsecondlv.path }" class="waves-effect">
              <FontAwesomeIcon fixed-width :icon="childsecondlv.icon_name || 'fe-arrow-right'" />
              <span> {{ childsecondlv.name }} </span>
            </router-link>
            <a v-else href="javascript: void(0);" class="waves-effect">
              <FontAwesomeIcon fixed-width :icon="childsecondlv.icon_name || 'fe-arrow-right'" />
              <span> {{ childsecondlv.name }} </span>
              <span v-if="childsecondlv.children" class="menu-arrow"></span>
            </a>
            <!-- <b-tooltip v-if="'hover_text' in childsecondlv && childsecondlv.hover_text" :target="`second-lv-${chsecondlvidx}-${entry.id}-${childsecondlv.id}`" placement="right" variant="info">
              {{ childsecondlv.hover_text }}
            </b-tooltip> -->
            <!-- if children of menu entry has more children 3rd level max -->
            <ul v-if="childsecondlv.children" class="nav-third-level nav" >
              <li v-for="(childthirdlv, chthirdlvidx) in childsecondlv.children" :id="`third-lv-${chthirdlvidx}-${entry.id}-${childsecondlv.id}`" :key="chthirdlvidx"  :class="{ active: childthirdlv.active }">
                <router-link v-if="'path' in childthirdlv && childthirdlv.path" tag="a" :to="{ path: childthirdlv.path }" class="waves-effect">
                  <FontAwesomeIcon fixed-width :icon="childthirdlv.icon_name || 'fe-arrow-right'" />
                  <span> {{ childthirdlv.name }} </span>
                </router-link>
                <a v-else  href="javascript: void(0);" class="waves-effect">
                  <FontAwesomeIcon fixed-width :icon="childthirdlv.icon_name || 'fe-arrow-right'" />
                  <span> {{ childthirdlv.name }} </span>
                </a>
                <!-- <b-tooltip v-if="'hover_text' in childthirdlv && childthirdlv.hover_text" :target="`third-lv-${chthirdlvidx}-${entry.id}-${childsecondlv.id}`" placement="right" variant="info">
                  {{ childthirdlv.hover_text }}
                </b-tooltip> -->
              </li>
            </ul>
          </li>
        </ul>
      </li>
    </ul>
    <!-- original menu
    <ul id="side-menu" class="metismenu">
      <li class="menu-title">Navigation</li>

      <li class="active">
        <a
          href="javascript: void(0);"
          aria-expanded="false"
          class="waves-effect"
        >
          <i class="fe-airplay"></i>
          <span class="badge badge-success badge-pill float-right">2</span>
          <span> Dashboards </span>
        </a>
        <ul class="nav-second-level" aria-expanded="false">
          <li>
            <router-link tag="a" to="/">Dashboard 1</router-link>
          </li>
          <li>
            <router-link tag="a" to="/dashboard2">Dashboard 2</router-link>
          </li>
        </ul>
      </li>

      <li>
        <a href="javascript: void(0);" class="waves-effect">
          <i class="fe-folder-plus"></i>
          <span> Multi Level </span>
          <span class="menu-arrow"></span>
        </a>
        <ul class="nav-second-level nav" aria-expanded="false">
          <li>
            <a href="javascript: void(0);">Level 1.1</a>
          </li>
          <li>
            <a href="javascript: void(0);" aria-expanded="false"
              >Level 1.2
              <span class="menu-arrow"></span>
            </a>
            <ul class="nav-third-level nav" aria-expanded="false">
              <li>
                <a href="javascript: void(0);">Level 2.1</a>
              </li>
              <li>
                <a href="javascript: void(0);">Level 2.2</a>
              </li>
            </ul>
          </li>
        </ul>
      </li>
    </ul> -->
    <div class="clearfix"></div>
  </div>
  <!-- End Sidebar -->
</template>

<style lang="scss">
@import '~metismenujs/scss/metismenujs';
</style>
